import React from 'react';
import { Lock, Megaphone, Calendar, BarChart3, Sparkles, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';

const features = [
    {
        icon: Megaphone,
        title: 'Multi-Platform Posting',
        description: 'Post to YouTube, Facebook, Instagram, and LinkedIn from one place'
    },
    {
        icon: Calendar,
        title: 'Content Calendar',
        description: 'Plan and schedule posts with our visual calendar interface'
    },
    {
        icon: BarChart3,
        title: 'Analytics Dashboard',
        description: 'Track engagement metrics across all your social accounts'
    },
    {
        icon: Sparkles,
        title: 'AI Content Assistant',
        description: 'Generate engaging content ideas with AI assistance (coming soon)'
    }
];

const UpgradePrompt = ({ onUpgrade }) => {
    return (
        <div className="flex-1 flex items-center justify-center p-8">
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                className="max-w-2xl w-full"
            >
                <div className="text-center mb-8">
                    <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-gradient-to-br from-purple-500 to-pink-500 shadow-lg shadow-purple-500/25 mb-6">
                        <Lock className="w-8 h-8 text-white" />
                    </div>
                    <h1 className="text-3xl font-bold text-slate-900 dark:text-white mb-3">
                        Social Media Management
                    </h1>
                    <p className="text-lg text-slate-600 dark:text-slate-400 max-w-md mx-auto">
                        Manage all your social media accounts in one place. Available on Ultra and Enterprise plans.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
                    {features.map((feature, index) => (
                        <motion.div
                            key={feature.title}
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: index * 0.1 }}
                            className="p-4 rounded-xl bg-white dark:bg-slate-800/50 border border-slate-200 dark:border-slate-700"
                        >
                            <div className="flex items-start gap-3">
                                <div className="p-2 rounded-lg bg-purple-100 dark:bg-purple-900/30">
                                    <feature.icon className="w-5 h-5 text-purple-600 dark:text-purple-400" />
                                </div>
                                <div>
                                    <h3 className="font-semibold text-slate-900 dark:text-white mb-1">
                                        {feature.title}
                                    </h3>
                                    <p className="text-sm text-slate-600 dark:text-slate-400">
                                        {feature.description}
                                    </p>
                                </div>
                            </div>
                        </motion.div>
                    ))}
                </div>

                <div className="text-center">
                    <button
                        onClick={onUpgrade}
                        className="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-gradient-to-r from-purple-600 to-pink-600 text-white font-semibold shadow-lg shadow-purple-500/25 hover:shadow-purple-500/40 transition-all hover:-translate-y-0.5"
                    >
                        Upgrade to Ultra
                        <ArrowRight className="w-5 h-5" />
                    </button>
                    <p className="mt-3 text-sm text-slate-500 dark:text-slate-400">
                        Starting at $99/month with 5 connected accounts
                    </p>
                </div>
            </motion.div>
        </div>
    );
};

export default UpgradePrompt;
